import { TFunction } from "i18next";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { NavItemButton } from "@/components/Layout/BaseLayouts/Footer/NavItems/NavItemButton";

import { Collapsible } from "./Collapsible/Collapsible";

/**
 * Returns the available languages.
 * @param t - The translation function.
 * @returns An array of objects containing the label and code of the languages.
 */
export const getLanguages = (t: TFunction) => [
  { label: t("Languages.german"), code: "de" },
  { label: t("Languages.english"), code: "en" },
  { label: t("Languages.french"), code: "fr" },
];

/**
 * This component is used to display the language menu in the footer.
 * It is a collapsible accordion-style menu that displays the available languages.
 * The menu can be toggled by clicking on the language label.
 **/
export const CollapsibleLanguageMenu = () => {
  const { i18n, t } = useTranslation();
  const languages = useMemo(() => getLanguages(t), [t]);

  return (
    <Collapsible id="language-menu" label={t("Common.language")}>
      {languages.map(({ label, code }) => (
        <NavItemButton
          key={`${code}-${label}`}
          label={label}
          selected={i18n?.resolvedLanguage === code}
          buttonHandler={() => i18n.changeLanguage(code)}
          inverted
        />
      ))}
    </Collapsible>
  );
};
